import { themeCollections } from "@/mocks/homeSections";

interface ThemeCollectionsProps {
  onOpen: (title: string) => void;
}

export default function ThemeCollections({ onOpen }: ThemeCollectionsProps) {
  return (
    <section id="collections" className="w-full border-t border-background-200 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              按主题分类整理
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
              把同题材的暗网流出物料归到一处，先看合集定位，再逐条翻原始片段，少走弯路。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 self-start whitespace-nowrap rounded-full border border-accent-300 bg-accent-100 px-3 py-1 text-xs text-accent-900">
            <i className="ri-folder-2-line"></i>
            3 个主题合集
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
          {themeCollections.map((col) => (
            <article
              key={col.id}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="h-40 w-full overflow-hidden bg-background-100">
                <img
                  src={col.cover}
                  alt={`黑网爆料 ${col.name} 主题合集封面`}
                  title={`${col.name} 暗网截图 隐藏网络`}
                  className="h-full w-full object-top"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between gap-3">
                  <h3 className="text-base font-semibold text-foreground-950">{col.name}</h3>
                  <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs whitespace-nowrap text-accent-900">
                    {col.count}
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{col.desc}</p>
                <button
                  type="button"
                  onClick={() => onOpen(col.name)}
                  className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
                >
                  进入合集
                  <i className="ri-arrow-right-up-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}